import { FETCH_STRIPE_CLIENT_SECRET_COMPLETED } from 'Rentlio/state/types'
import createReducer from 'Rentlio/state/utils/createReducer'

const initialState = {}

const stripe = createReducer(initialState)({
  [FETCH_STRIPE_CLIENT_SECRET_COMPLETED]: (state, action) => {
    return { ...action.payload }
  }
})

export default stripe
